import { useSelector } from 'react-redux';
import { Command, State } from '@store/index';
import { useMemo } from 'react';

interface Props {
  command: Command | undefined;
}

export const useNodeError = ({ command }: Props) => {
  const workflow_id = useSelector((state: State) => state.tabs.active.flow?.flow_id);

  const errorObject = useSelector((state: State) =>
    state.tabs.active.nodeErrors.find((item) => item?.id === command?.node?.id && item.workflowId === workflow_id)
  );

  const statusId = command ? `${command.node.id}/${workflow_id}` : null;
  const nodeStatusValue = useSelector((state: State) => (statusId ? state.tabs.active.run.status[statusId] : null));

  const nodeError = errorObject?.error?.message || undefined;
  const nodeLoading = nodeStatusValue === 'processing';
  const isNodeError = nodeStatusValue === 'failed' || !!nodeError;

  const nodeStatus = useMemo(() => {
    if (nodeLoading) return 'processing';
    if (nodeError) return 'failed';
    if (nodeStatusValue === 'cancelled') return 'pending';
    if (command && nodeStatusValue) return nodeStatusValue;
    return 'none';
  }, [nodeLoading, nodeError, nodeStatusValue, command]);

  return { isNodeError, nodeError, nodeStatus, nodeLoading };
};
